// extracted by mini-css-extract-plugin
module.exports = {"administrationTabContent":"NJe0b"};